import {API_APP_TEMPLATE, API_APP_DETAILS} from '../../configs/apis';
import {
  ON_APPLICATION_TEMPLATE_FETCH_REQUEST,
  ON_APPLICATION_TEMPLATE_FETCH_SUCCESS,
  ON_APP_DETAILS_FETCH_REQUEST,
  ON_APP_DETAILS_FETCH_SUCCESS,
} from '../types';
import Api from '../../utils/api';
import {handleError} from '../error';

export function fetchTemplate(appId) {
  return async (dispatch) => {
    try {
      dispatch({type: ON_APPLICATION_TEMPLATE_FETCH_REQUEST});
      const template = await Api.get(API_APP_TEMPLATE, {}, {appId});

      return dispatch({type: ON_APPLICATION_TEMPLATE_FETCH_SUCCESS, template});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}
export function fetchDetails(appId) {
  return async (dispatch) => {
    try {
      dispatch({type: ON_APP_DETAILS_FETCH_REQUEST});
      const details = await Api.get(API_APP_DETAILS, {}, {appId});

      return dispatch({type: ON_APP_DETAILS_FETCH_SUCCESS, details});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}
